import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from '../../components/panel/panel.jsx';
import { toast } from 'react-toastify';
import axios from 'axios'
import Select from 'react-select';
import Pagination from '../../components/pagination/pagination.jsx';
import Modal from 'react-modal';
import moment from 'moment/moment.js';
import ProvinceForm from './city.jsx';

import ModalWithProceed from '../../components/prompt/ModalWithProceed.jsx';
import { isEmpty } from "../../helper/helper.js"

function CityList({ props = {} }) {

  const [dataTable, setDataTable] = useState([])
  const [state, setState] = useState({});
  const [formData, setFormData] = useState({ mProvince: [], currentPage: 1, rowsPerPage: 50 });
  const [formIsOpen, setFormIsOpen] = useState(false);
  const [modalUid, setModalUid] = useState('')

  const [promptDeleteIsOpen, setPromptDeleteIsOpen] = useState(false);

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target

    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

  const handleOnChangeSelect = (option, e) => {
    if (e.action === "select-option") {
      setState(prevState => ({
        ...prevState,
        [e.name]: option.value,
      }))
    } else {
      setState(prevState => ({
        ...prevState,
        [e.name]: '',
      }))
    }
  }

  const openCityForm = async (uid, e) => {
    e.preventDefault();
    setModalUid(uid)
    setFormIsOpen(true) 
  }

  const confirmDeleteCity = async () => {
    setPromptDeleteIsOpen(false)

    if (isEmpty(formData.id)) {
      return
    }


    await axios.delete(`${window.API_HOST}/v1/city/${formData.id}`)
      .then(res => {
        const data = res.data;

        toast.success(`Success delete city ${formData.name}`)
        refreshTable()

      }).catch(err => {
        toast.error(err.response?.data?.error ?? `Can't delete ${formData.name}`)

      })
  }

  const refreshTable = async (_page, _size) => {

    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      province: state.province ?? '',
      city: state.city ?? ''
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }
    
    await axios.get(`${window.API_HOST}/v1/city`, { params })
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData(prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }

  const searchForm = async () => {
    setFormData(prevState=>({
      ...prevState ,
      currentPage: 1
     }))
    await refreshTable(1)

  }


  const fetchForm = async () => {
    await axios.get(`${window.API_HOST}/v1/city/form`)
      .then(res => {
        const data = res.data;
        setFormData(prevState => ({
          ...prevState,
          mProvince: data.data.province
        }))

      }).catch(err => {

      })
  }

  useEffect(() => {
    searchForm()
    fetchForm()
  }, []) //eslint-disable-next-line 


  const customStyles = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">City <small></small></h1>
      <Panel>
        <PanelHeader noButton>City List</PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-4'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Province</label>
                <div className="col-sm-9">
                  <Select name="province" placeholder={"Province"}
                    value={formData.mProvince.find(({ value }) => { return value === state.province }) ?? ""}
                    options={formData.mProvince}
                    onChange={handleOnChangeSelect}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">City</label>
                <div className="col-sm-9">
                  <input type="text" name="city" value={state.city ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => { }}><span className="fa fa-sm fa-download"></span> Download</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={(e) => { openCityForm(null, e) }}><span className="fa fa-plus-circle fa-sm"></span> New</button>
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className="table table-hover mb-0 text-dark">
            <table className="table table-sm table-hover table-striped mb-0 text-dark">
              <thead className='bg-lime-400 fw-bold'>
                <tr>
                  <th>No.</th>
                  <th className='w-90px'>Code</th>
                  <th>Name</th>
                  <th>Alias</th>
                  <th>Province</th>
                  <th>Active</th>
                  <th>Last Update</th>
                  <th>Updated By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(dataTable).map((val, key) => {
                  return (
                    <tr className='fs-8 fw-light' key={key}>
                      <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                      <td>{val.city_code}</td>
                      <td>{val.city_name}</td>
                      <td>{val.other_name}</td>
                      <td>{val.province_name}</td>
                      <td>{val.active ? 'Yes' : 'No'}</td>
                      <td>{moment(val.updated_at).format('YYYY-MM-DD HH-mm:ss')}</td>
                      <td>{val.updated_by}</td>
                      <td><button className='btn btn-xs me-3' onClick={(e) => { openCityForm(val.id, e) }}><i className='fa fa-pen-to-square'></i></button> <button className='btn btn-xs'><i className='fa fa-trash text-danger' onClick={() => {
                        setFormData(prevState => ({
                          ...prevState,
                          name: val.city_name,
                          id: val.id
                        }))
                        setPromptDeleteIsOpen(true);
                      }}></i></button></td>
                    </tr>)
                })}
              </tbody>
            </table>
          </div>
        </PanelBody>
        <PanelFooter>
          <div className='row'>
            <div className="col-sm-12">
              <Pagination
                currentPage={formData.currentPage ?? 1}
                totalRows={formData.totalRows ?? 1}
                pageSize={formData.rowsPerPage ?? 50}
                onPageChange={onChangePageHandler}
                selectedPageHandler={onChangePageSelectHandler}
              />
            </div>
          </div>
        </PanelFooter>
      </Panel>
      <>
        <Modal
          isOpen={formIsOpen}
          onAfterOpen={() => { }}
          onRequestClose={() => setFormIsOpen(false)}
          style={customStyles}
          ariaHideApp={false}  >
          <ProvinceForm props={{
            uid: modalUid, cancelAction: () => {
              setFormIsOpen(false)
            }
          }} />
        </Modal>


        <ModalWithProceed header={false} show={promptDeleteIsOpen} close={() => { setPromptDeleteIsOpen(false) }} proceed={confirmDeleteCity}>
          Do you want to delete <strong>{formData.name}</strong> ?
        </ModalWithProceed>

      </>
    </div>
  )
}

export default CityList;